import React from 'react';

import { Flex } from '@chakra-ui/react';

import { Select } from 'uiToolkitV1/Select';
import { stylesForMenuPortalReviewDropdown } from 'uiToolkitV1/Select/Select.styles';
import { TextLabel } from 'uiToolkitV1/Typography';

const DropDown = ({
  label = 'Assessment',
  value,
  options = [],
  onChange = () => {},
  isMulti = false,
  helperText = '',
  className = '',
  isDisabled = false,
  LabelComponent = null,
}) => (
  <Flex flexDir="column">
    {LabelComponent ? (
      <LabelComponent />
    ) : (
      <TextLabel bold color="text.g2" mb="4px">
        {label}
      </TextLabel>
    )}

    <Flex
      sx={{
        '.select': { width: '100%' },
        '.select__menu': { marginLeft: '0 !important' },
        '.chakra-form-control': {
          padding: 0,
        },
        '.select__control': { padding: '12px', fontSize: '16px!important' },
      }}
    >
      <Select
        withBackground
        handleChange={(val) => {
          onChange({ answer: val });
        }}
        variant="outlined"
        value={value}
        options={options}
        isSearchable={false}
        isMulti={isMulti}
        helperText={helperText}
        className={className}
        menuPortalTarget={document.body}
        menuPortalStyles={stylesForMenuPortalReviewDropdown}
        isDisabled={isDisabled}
      />
    </Flex>
  </Flex>
);

export default DropDown;
